export const BACK_URL = 'http://220.120.75.51:8900';
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const MAP_DEFAULT_CENTER = { lat: 36.650879, lng: 127.468983 };
